export const state = {
  brandnamicContacts: [],
  brandnamicMeta: {},
  brandnamicContact: null,
  brandnamicPersonalitiesMap: {},
  brandnamicSelectedPersonalities: {},
  brandnamicActivePersonality: null,
  uiFlags: {
    isFetching: false,
  },
};
